import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/content';
import { CtaButton } from './CtaButton';
const included = ['Los 6 Tomos Maestros (+120 páginas)', '5 Bonos exclusivos incluidos', 'Para todos los niveles', 'Acceso inmediato', 'Garantía Sigma 7 días'];
const guarantees = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta · Stripe · Bizum'
}];
type OfferCardProps = {
  ctaLabel?: string;
  className?: string;
};
export function OfferCard({
  ctaLabel = '👉 Sí, quiero el Padel Pro-Pack',
  className = ''
}: OfferCardProps) {
  return <div className={`mx-auto max-w-2xl rounded-3xl border border-ball-400/40 bg-ink-900 p-7 text-left shadow-ball sm:p-10 ${className}`} style={{
    paddingTop: "13px",
    paddingBottom: "17px"
  }} data-id="element-134" data-mp="22w3nn0cepxq0">
      <h3 className="font-display text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-135" data-mp="8fb19bdvshdi">
        🏆 Pro-Pack Definitivo
      </h3>
      <p className="mt-3 text-sm text-slate-400" style={{
      paddingTop: "16px",
      marginTop: "-10px",
      marginBottom: "-10px"
    }} data-id="element-136" data-mp="ddkz5tqzpw2t">El sistema completo para ordenar tus sesiones.</p>

      <ul className="mt-7 space-y-3 border-y border-ink-600 py-7" style={{
      paddingTop: "16px",
      paddingBottom: "0px",
      marginTop: "-10px",
      marginBottom: "-10px"
    }} data-id="element-137" data-mp="3nrw5h4wypa6">
        {included.map(item => <li key={item} className="flex items-center gap-3 text-[15px] text-slate-200" data-id="element-138" data-mp="3qvder6a13ib0">
            <CheckIcon className="h-5 w-5 shrink-0 text-ball-400" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="3cvlwuuge5hrq" />
            {item}
          </li>)}
      </ul>

      <div className="mt-7 flex flex-wrap items-end gap-4" style={{
      paddingTop: "19px",
      marginTop: "-10px",
      marginBottom: "-10px"
    }} data-id="element-140" data-mp="1b2o7x9pqj9c2">
        <span className="text-xl font-semibold text-slate-500 line-through" data-id="element-141" data-mp="1f3q2hd8pix7p">{PRICE.regular}</span>
        <span className="font-display text-6xl leading-none text-ball-400" style={{
        fontSize: "48px"
      }} data-id="element-142" data-mp="2o2rg3vp22ma0">{PRICE.amount}</span>
        <span className="pb-2 text-sm font-bold uppercase tracking-widest text-slate-400" data-id="element-143" data-mp="2f0i9hgwwrd1w">eur</span>
      </div>

      <CtaButton size="lg" className="mt-7 w-full" href={CHECKOUT_URL} data-id="element-144" data-mp="2a1owdplj9o29">
        {ctaLabel}
      </CtaButton>

      <ul className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3" data-id="element-145" data-mp="36s7mgznf98yc">
        {guarantees.map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-2 text-xs font-medium text-slate-400" data-id="element-146" data-mp="32qw33bv55jyl">
            <Icon className="h-4 w-4 text-court-400" aria-hidden="true" data-id="element-147" data-mp="2xxjf93yadh6w" />
            {label}
          </li>)}
      </ul>
    </div>;
}